import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalFile } from 'src/app/models/GlobalFile';

@Component({
    selector: 'app-link-global-file-modal',
    templateUrl: './link-global-file-modal.component.html',
    styleUrls: ['./link-global-file-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class LinkGlobalFileModalComponent implements OnInit {
    public emitObject: EventEmitter<GlobalFile> = new EventEmitter();

    @Input() data: GlobalFile[] = [];
    @Input() add: (file: GlobalFile) => void;
    formGroup: UntypedFormGroup;

    constructor(public activeModal: NgbActiveModal, private formBuilder: UntypedFormBuilder) {}

    ngOnInit(): void {
        this.formGroup = this.formBuilder.group({
            file: '',
        });
    }

    onSubmit() {
        this.emitObject.emit(this.formGroup.get('file').value);
        this.activeModal.close();
    }
}
